import { useTranslation } from 'react-i18next'
import { LOCALE_NAMES, SUPPORTED_LOCALES, setLocale, useLocale } from '@/i18n'
import './LocaleSwitcher.css'

interface Props {
  className?: string
}

// Компактный переключатель языка: показывает код текущей локали, клик — следующая из
// SUPPORTED_LOCALES по кругу (новый язык встанет в цикл без правок). Квадрат того же
// размера, что кнопки админки/выхода, — хедер не переполняется на узкой ширине.
export function LocaleSwitcher({ className }: Props) {
  const { t } = useTranslation()
  const locale = useLocale()
  const next = SUPPORTED_LOCALES[(SUPPORTED_LOCALES.indexOf(locale) + 1) % SUPPORTED_LOCALES.length]
  // Эндоним целевого языка не переводится: «English» и в русском интерфейсе.
  const label = t(($) => $.locale.switchTo, { language: LOCALE_NAMES[next] })
  return (
    <button
      type="button"
      className={`locale-switcher${className ? ` ${className}` : ''}`}
      onClick={() => setLocale(next)}
      title={label}
      aria-label={label}
    >
      {locale}
    </button>
  )
}
